import React from 'react';
import Icon from '../../../components/AppIcon';

const kpiConfig = [
  { key: 'totalEvents', label: 'Total Events', icon: 'Activity', color: '#107570' },
  { key: 'formViews', label: 'Form Views', icon: 'Eye', color: '#0d9488' },
  { key: 'conversionRate', label: 'Conversion Rate', icon: 'TrendingUp', color: '#14b8a6' },
  { key: 'avgTimeOnForm', label: 'Avg. Time on Form', icon: 'Clock', color: '#6366f1' },
  { key: 'abandonRate', label: 'Abandon Rate', icon: 'LogOut', color: '#f59e0b' },
  { key: 'paymentSuccess', label: 'Payment Success', icon: 'BadgeCheck', color: '#22c55e' },
];

const EventKPIs = ({ data }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {kpiConfig?.map((cfg) => {
        const kpi = data?.[cfg?.key];
        return (
          <div key={cfg?.key} className="bg-card border border-border rounded-xl p-4 flex flex-col gap-2">
            <div className="flex items-center justify-between">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${cfg?.color}18` }}
              >
                <Icon name={cfg?.icon} size={15} color={cfg?.color} />
              </div>
              <span
                className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${
                  kpi?.positive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
                }`}
              >
                {kpi?.change}
              </span>
            </div>
            <div>
              <p className="text-xl font-bold text-foreground leading-tight">{kpi?.value?.toLocaleString?.() ?? kpi?.value}</p>
              <p className="text-[11px] text-muted-foreground mt-0.5 leading-tight">{cfg?.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EventKPIs;
